/* eslint-disable no-undef */
import PropTypes from 'prop-types'
import React from 'react'
import Link from 'next/link'
import ReactSVG from 'react-svg'
import { CookiesHelper } from 'Core/cookiesHelper/CookiesHelper'
import Router from 'next/router'
import { AdditionalPreloader } from 'SRC/ui/Preloader'
import {
  RightColumnImages,
  // RightColumnOfferPrice,
  RightColumnShare,
  RightColumnVehicleRegistration
} from '../../../components'
import { getCurrentAd } from 'SRC/modules/ads/detail/selectors'
import Lightbox from 'react-images'
import { connect } from 'react-redux'
import { ImageManager } from 'Core/imageManager'
import { getAdThumbnailUrl, getAdImageUrl } from 'SRC/modules/ads/shared/functions'
import { getCurrentSubCategory } from 'SRC/modules/categories/selectors'
import { fetchCart, addCartItem, removeCartItem } from 'SRC/modules/shoppingCart/actions'
import { getCart, getCartItemLoading, getCartInitiallyFetched } from 'SRC/modules/shoppingCart/selectors'
import { AdImagesBanners } from '../../Banners'

export class RightColumn extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      lightboxIsOpen: false,
      currentImage: 0
    }

    this.cookies = new CookiesHelper()
    this.im = new ImageManager()

    // const { fetchCart, isCartInitiallyFetched } = props
    // !isCartInitiallyFetched && fetchCart && fetchCart()
  }

  getVisibleImagesLength = () => this.props.ad ? this.props.ad.media.filter(item => item.visible).length : 0

  openLightbox = (index, event) => {
    event.preventDefault()
    this.setState(prevState => ({
      ...prevState,
      currentImage: index,
      lightboxIsOpen: true
    }))
  }

  closeLightbox = () => {
    this.setState(prevState => ({
      ...prevState,
      currentImage: 0,
      lightboxIsOpen: false
    }))
  }

  goToPrevious = () => {
    this.setState(prevState => ({
      ...prevState,
      currentImage: this.state.currentImage === 0 ? this.getVisibleImagesLength() - 1 : this.state.currentImage - 1
    }))
  }

  goToNext = () => {
    this.setState(prevState => ({
      ...prevState,
      currentImage: this.state.currentImage === this.getVisibleImagesLength() - 1 ? 0 : this.state.currentImage + 1
    }))
  }

  goToImage = (index) => {
    this.setState(prevState => ({
      ...prevState,
      currentImage: index
    }))
  }

  handleClickImage () {
    if (this.state.currentImage === this.getVisibleImagesLength() - 1) return
    this.goToNext()
  }

  getVisibleImages = () => this.props.ad.media && Array.isArray(this.props.ad.media)
    ? this.props.ad.media.filter(item => item.visible)
    : []

  getImagesForColumn = () => {
    const visibleImages = this.getVisibleImages()
    return visibleImages.length ? visibleImages.map(item => getAdImageUrl(item)) : null
  }

  getLightBoxImages = () => {
    const visibleImages = this.getVisibleImages()
    return visibleImages.length
      ? visibleImages.map(item => ({
        src: getAdImageUrl(item),
        thumbnail: getAdThumbnailUrl({ image: item })
      }))
      : null
  }

  getCustomControls = () => {
    const { ad } = this.props
    return (
      <React.Fragment>
        <AdImagesBanners key='ad-images-banners' currentImage={this.state.currentImage} />

        <div className='image-sides image-left' key='image-left' onClick={this.goToPrevious}>
          <div className='arrow arrow-left'>
            <div className='arrow_icon arrow-left_icon' />
          </div>
        </div>

        <div className='image-sides image-right' key='image-right' onClick={this.goToNext}>
          <div className='arrow arrow-right'>
            <div className='arrow_icon arrow-right_icon' />
          </div>
        </div>

        <div className='lightbox-custom-header' key='lightbox-custom-header'>
          <span>{`${this.state.currentImage + 1}/${this.getVisibleImagesLength()}`}</span>
          <span>{ad && ad.titleCompiled ? ad.titleCompiled : ''}</span>
        </div>

        <span />
      </React.Fragment>
    )
  }

  checkCartItem = () => {
    const { cartItems, ad } = this.props
    console.log('cartitems ad', cartItems, ad)

    const username = ad && ad.user && ad.user.username
    if (username && Array.isArray(cartItems) && ad && ad.id) {
      const userItems = cartItems.find(userItems => userItems.user && userItems.user.username === username)

      if (userItems && Array.isArray(userItems.items)) {
        console.log('userItems', userItems.items)

        return Boolean(userItems.items.find(item => item.ad === ad.id))
      }
    }

    return false
  }

  addItemToCart = () => {
    const { ad, addCartItem } = this.props

    const userId = this.cookies.get('userId')
    const token = this.cookies.get('token')

    if (userId && token) {
      const payload = {
        ad: ad && ad.id,
        userId,
        token
      }

      addCartItem(payload)
    } else {
      Router.push('/profile', '/profil')
    }
  }

  removeItemFromCart = () => {
    const { ad, removeCartItem } = this.props

    const userId = this.cookies.get('userId')
    const token = this.cookies.get('token')

    if (userId && token) {
      const payload = {
        ad: ad && ad.id,
        userId,
        token
      }

      removeCartItem(payload)
    } else {
      Router.push('/profile', '/profil')
    }
  }

  renderCartButton = () => {
    const { cartItemLoading } = this.props

    const checkCartItem = this.checkCartItem()

    console.log('checkCartItem', checkCartItem)

    return <button
      className='oglasi-add-to-cart-btn'
      onClick={!checkCartItem ? this.addItemToCart : () => {
        Router.push('/profile?page=cart', '/profil/cart')
      }}
    >
      {cartItemLoading
        ? <AdditionalPreloader type='small' />
        : <React.Fragment>
          <span className='oglasi-add-to-cart-btn_icon'>
            <ReactSVG src='/icons/shopping_cart.svg' beforeInjection={svg => {
              svg.setAttribute('style', 'width: 25px; height: 100%;')
            }} wrapper='span' />
          </span>
          <p className='oglasi-add-to-cart-btn_text'>{!checkCartItem ? 'Dodaj u korpu' : 'Dodato u korpu'}</p>
        </React.Fragment>}
    </button>
  }

  render () {
    const { registrationFormulas, isMyAd, ad } = this.props

    const lightboxImages = this.getLightBoxImages()
    const customControls = this.getCustomControls()

    const theme = {
      arrow__size__medium: {
        display: 'none'
      }
    }

    const adSeo = this.props.ad ? this.props.ad.seo : ''

    const displayVehicleRegistration = registrationFormulas && Array.isArray(registrationFormulas) && registrationFormulas.length

    return (
      <div className='oglasi-info-right'>
        {
          lightboxImages
            ? <Lightbox
              currentImage={this.state.currentImage}
              images={lightboxImages}
              isOpen={this.state.lightboxIsOpen}
              onClickImage={this.handleClickImage}
              onClickNext={this.goToNext}
              onClickPrev={this.goToPrevious}
              onClose={this.closeLightbox}
              onClickThumbnail={this.goToImage}
              showThumbnails
              backdropClosesModal
              customControls={[customControls]}
              showCloseButton={false}
              theme={theme}
            />
            : null
        }
        <RightColumnImages ad={ad} onClick={this.openLightbox} length={this.getVisibleImagesLength()} />
        <RightColumnShare />
        {isMyAd
          ? <Link href={{ pathname: 'editAd', query: { ad: adSeo } }} as={`/profil/oglasi/izmeni/${adSeo}`}>
            <a className='oglasi-edit-btn'>Izmijeni oglas</a>
          </Link> : null}
        {/* {!isMyAd && ad.deliver
          ? this.renderCartButton() : null} */}
        {displayVehicleRegistration && !ad.isBuying
          ? (
            <RightColumnVehicleRegistration
              price={ad.registrationCost ? ad.registrationCost.toFixed(2) : 0}
            />
          )
          : null
        }
      </div>
    )
  }
}

RightColumn.propTypes = {
  ad: PropTypes.shape({
    id: PropTypes.number.isRequired,
    seo: PropTypes.string.isRequired,
    deliver: PropTypes.bool.isRequired,
    price: PropTypes.number.isRequired,
    titleCompiled: PropTypes.string.isRequired,
    oldPrice: PropTypes.number,
    priceType: PropTypes.number.isRequired,
    media: PropTypes.arrayOf(PropTypes.shape({
      fd: PropTypes.string,
      visible: PropTypes.bool
    })),
    user: PropTypes.shape({
      id: PropTypes.number,
      username: PropTypes.string
    }).isRequired,
    registrationCost: PropTypes.number,
    isBuying: PropTypes.bool
  }).isRequired,
  isMyAd: PropTypes.bool.isRequired,
  isCartInitiallyFetched: PropTypes.bool.isRequired,
  registrationFormulas: PropTypes.array.isRequired,
  cartItems: PropTypes.array.isRequired,
  cartItemLoading: PropTypes.bool.isRequired,
  fetchCart: PropTypes.func.isRequired,
  addCartItem: PropTypes.func.isRequired,
  removeCartItem: PropTypes.func.isRequired
}

const mapStateToProps = state => {
  const ad = getCurrentAd(state)

  if (ad && ad.media && Array.isArray(ad.media)) {
    ad.media.sort((a, b) => a.priority - b.priority)
  }

  const category = getCurrentSubCategory(state)

  return {
    ad,
    registrationFormulas: category && category.registrationFormulas ? category.registrationFormulas : [],
    cartItems: getCart(state),
    cartItemLoading: getCartItemLoading(state),
    isCartInitiallyFetched: getCartInitiallyFetched(state)
  }
}

export default connect(mapStateToProps, { fetchCart, addCartItem, removeCartItem })(RightColumn)
